import {
  Button as MuiButton,
  Typography as MuiTypography,
  DialogContent as MuiDialogContent,
} from '@material-ui/core';
import styled from 'styled-components/macro';

const DialogContent = styled(MuiDialogContent)`
  padding: 32px;
  height: 100%;
  position: relative;
`;

const ButtonContainer = styled.div`
  display: flex;
  position: absolute;
  bottom: 24px;
  right: 24px;
`;

const FlexButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const NoButton = styled(MuiButton)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px 16px;
  width: 50px;
  height: 32px;
  background: #FEFEFE;
  border: 1px solid #DADADD;
  box-sizing: border-box;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.016);
  border-radius: 2px;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin-right: 4px;
  :hover {
    background: #BEBEBE;
    border: 1px solid #ADADAD
  }
`;

const NoButtonText = styled(MuiTypography)`
  font-family: Proxima Nova;
  font-size: 14px;
  text-transform: none;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
  color: #202625;
`;

const YesButton = styled(MuiButton)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px 8px;
  width: 155px;
  height: 32px;
  background: ${(props) => (props.disabled ? '#999999' : '#1F2E81')};
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.043);
  border-radius: 2px;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin-left: 4px;
  :hover {
    background: #303F92;
    border: 1px solid #303F92
  }
`;

const YesButtonText = styled(MuiTypography)`
  font-family: Proxima Nova;
  font-size: 14px;
  text-transform: none;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
  color: #FEFEFE;
`;

const HeaderText = styled(MuiTypography)`
  font-family: Proxima Nova;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0px;
  text-align: left;
  margin-bottom: 8px;
`;

const BodyText = styled(MuiTypography)`
  font-family: Proxima Nova;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
`;

const ErrorText = styled(MuiTypography)`
  font-family: Proxima Nova;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: red;
`;

const TextContainer = styled.div`
  margin-left: 16px;
  width: 100%;
`;

const WarningSVGContainer = styled.div`
  margin: 6px 0px;
  display: inline;
`;

const WarningSVG = styled.img`
  margin: 0px 0px;
  height: 22px;
  width: 22px;
`;

export default {
  DialogContent,
  TextContainer,
  ButtonContainer,
  FlexButtonContainer,
  WarningSVGContainer,
  WarningSVG,
  HeaderText,
  BodyText,
  ErrorText,
  NoButton,
  NoButtonText,
  YesButton,
  YesButtonText,
};
